import type { IconButtonProps } from '@mui/material';
import { IconButton } from '@mui/material';
import type { FixedProductInput } from '@weft/types';
import { withDefault } from '@weft/utils';
import { useFormContext } from 'react-hook-form';
import { CloseIcon } from '../../../../../../components/icons';
import type { NewPlanForm } from '../../CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';

type RemoveFixedProductRowProps = {
  fixedProduct: FixedProductInput;
} & IconButtonProps;

export const RemoveFixedProductRow: React.FC<RemoveFixedProductRowProps> = ({ fixedProduct, ...props }) => {
  const { setValue, getValues } = useFormContext<PlanInputForm, NewPlanForm>();

  const handleRemoveRow = () => {
    const products = getValues('fixedProducts');
    const updatedProducts = withDefault(products, []).filter((product) => product.id !== fixedProduct.id);
    setValue('fixedProducts', updatedProducts);
  };

  return (
    <IconButton
      className="h-6 w-6"
      onClick={handleRemoveRow}
      {...props}
    >
      <CloseIcon />
    </IconButton>
  );
};